module.exports = __webpack_public_path__ + "media/images/leaflet/images/layers-2x-8f2c4d11474275fbc1614b9098334eae.png";